export const OurRoutes = {
  mainPage: "/",
  about: "/aboutUs",
  contactUs: "/contactUs",
  infisuite: "/infisuite",
};
